import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { RiDeleteBin6Line } from 'react-icons/ri';
import axios from 'axios';
import ResponseMsg2 from '../../general/ResponseMsg2'
import { FaCheck } from 'react-icons/fa';


const AssignVehicle = ({ setLoading }) => {
    const [formData, setFormData] = useState({
        route: '',
        vehicle: ''
    });

    const [vehicleRoutes, setVehicleRoutes] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [assignVehicle, setAssignVehicle] = useState([]);

    const [showDelete, setShowDelete] = useState(false);
    const [selectedRoute, setSelectRoute] = useState('');

    // search-filter
    const [searchFilter, setSearchFilter] = useState('');
    const [response2, setResponse2] = useState({ message: '', status: 'success' });



    // delete
    const handleDelete = async (id) => {
        setLoading(true);
        try {
            const res = await axios.put(`https://api.kcian.in/delete-assign-vehicle/${id}`);

            setResponse2({ message: 'Vehicle has been Unassigned.', status: 'success' });
            setShowDelete(false);
            fetchAssignedVehicle();
            fetchVehicle();
            fecthVehicleRoute();
        } catch (err) {
            console.error(err.response?.data || err.message);
        } finally {
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
            setLoading(false);
        }
    };
    

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const res = await axios.put(
                "https://api.kcian.in/add-assign-vehicle",
                formData,
                { headers: { "Content-Type": "application/json" } }
            );

            setResponse2({ message: 'Route Assigned to Vehicle.', status: 'success' });
            fetchAssignedVehicle();

        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
        } finally {
            setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
        }
    };


    useEffect(() => {
        fetchVehicle();
        fecthVehicleRoute();
        fetchAssignedVehicle();
    }, []);


    const fetchVehicle = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.kcian.in/fetch-vehicle');
            setVehicles(res.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const fecthVehicleRoute = async () => {
        setLoading(true);

        try {
            const res = await axios.get('https://api.kcian.in/fetch-vehicle-route');
            setVehicleRoutes(res.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    const fetchAssignedVehicle = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.kcian.in/fetch-assigned-vehicle');
            setAssignVehicle(res.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const filteredData = assignVehicle.filter((r) => {
        const term = searchFilter.toLowerCase();
        return (
            r.title.toLowerCase().includes(term) ||
            r.fare.toLowerCase().includes(term)
        )
    });

    const handleShowDelete = (item) => {
        setSelectRoute(item);
        setShowDelete(true);
    }


    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Transport' message2='Assign Vehicle' />

                    {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                            <div className='profile-card'>
                                <p className="profile-heading">Add Assign Vehicle</p>
                                <form className='mt-4' onSubmit={handleSubmit} >
                                    <div className='mb-4'>
                                        {/* Route */}
                                        <div className='profile-input-area mt-4'>
                                            <label className='profile-badge'>Route*</label>
                                            <select
                                                name="route"
                                                className="profile-input"
                                                value={formData.route}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select Route...</option>
                                                {vehicleRoutes
                                                    .filter(route => route.vehicle_id == null)
                                                    .map(model => (
                                                        <option key={model.id} value={model.id}>
                                                            {model.title}
                                                        </option>
                                                    ))
                                                }
                                                </select>
                                        </div>
                                        {/* Vehicle */}
                                        <div className='profile-input-area mt-4'>
                                            <label className='profile-badge'>Vehicle*</label>

                                            <select
                                                className="profile-input"
                                                name="vehicle"
                                                value={formData.vehicle}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select Vehicle Model...</option>
                                                {vehicles.filter(vehicle => 
        !vehicleRoutes.some(route => route.vehicle_id == vehicle.id)
      ).map((model) => (
                                                    <option key={model.id} value={model.id}>
                                                        {model.vehicle_model}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>
                                    {/* SAVE */}
                                    <div className='d-flex justify-content-center'>
                                        <button type='submit' className='profile-btn' ><FaCheck /> SAVE</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* table-section */}
                        <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                            <div className='profile-card'>

                                <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                    <span className="profile-heading align-content-center">Assigned Vehicle List</span>

                                    <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                        <input
                                            type='text'
                                            name='search'
                                            className='profile-input border-bottom rounded-0'
                                            placeholder='Search...'
                                            value={searchFilter}
                                            onChange={(e) => setSearchFilter(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='w-100 text-center'>

                                        <thead className='account-thead'>
                                            <tr>
                                                <th className='rounded-start-4'>SL</th>
                                                <th>Route</th>
                                                <th>Fare</th>
                                                <th>Vehicle No (Model No)</th>
                                                <th className='rounded-end-4'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.filter(item => item.vehicle_id != null).length > 0 ? (
                                                filteredData.map((item, id) => (
                                                    <tr className='account-tr' key={id}>
                                                        <td>{id + 1}</td>
                                                        <td>{item.title}</td>
                                                        <td>{item.fare}</td>
                                                        <td>{item.vehicle_no} ({item.vehicle_model})</td>
                                                        <td>
                                                            {/* <MdOutlineEdit className='account-icon1 mt-2' title='Edit'
                                                                onClick={() => handleEdit(item)} /> */}
                                                            <RiDeleteBin6Line className='account-icon1' title='Remove'
                                                                onClick={() => handleShowDelete(item)} />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr className='account-tr'>
                                                    <td colSpan="4">
                                                        No Data found.
                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                </div>

                                {showDelete && (
                                    <>
                                        <section className='ins-dialog'>
                                            <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

                                                <p className='ins-dialog-heading text-danger'>Remove This Assigned Vehicle!</p>

                                                <div className='table-responsive'>
                                                    <table className='w-100'>

                                                        <thead className='account-thead'>
                                                            <th className='rounded-start-4'>Route</th>
                                                            <th>Fare</th>
                                                            <th>Vehicle No</th>
                                                            <th className='rounded-end-4'>Model No</th>                                                        </thead>

                                                        <tr className='account-tr'>
                                                            <td>{selectedRoute.title}</td>
                                                            <td>{selectedRoute.fare}</td>
                                                            <td>{selectedRoute.vehicle_no}</td>
                                                            <td>{selectedRoute.vehicle_model}</td>
                                                        </tr>


                                                    </table>
                                                </div>

                                                <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Assigned Vehicle will be permanently removed.</p>

                                                <button className='profile-btn me-2' onClick={() => handleDelete(selectedRoute.id)}>Remove</button>
                                                <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


                                            </div>
                                        </section>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AssignVehicle